const allowedOrderTypesReducer = (allowedOrderTypes = {}, action) => {
    switch (action.type) {
        case "ADD_ALLOWED_ORDER_TYPES":
            return action.payload;
        default:
            return allowedOrderTypes;
    }
};

export default allowedOrderTypesReducer;